// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"542":"e2ec0b96","922":"dc477248"}[chunkId] + ".chunk.js";
};